import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const PossibleTag = (props) => {
    const { children, className = '', isPossible = true } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex items-center justify-center', 'min-h-24 py-4 px-8', 'text-center', 'rounded-sm', isPossible ? 'bg-gray-50' : 'bg-gray-100', isPossible ? 'text-blue-100' : 'text-inactive', isPossible && 'border-solid border-turquoise-blue-50', className) }, { children: _jsx(Text, Object.assign({ color: 'none', size: 'xs' }, { children: children })) })));
};
